import React from 'react';

import type { FC } from 'react';

export const Flag: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
      <path d="M11.5833 4.58464L11.3833 3.58464C11.3083 3.2013 10.9667 2.91797 10.5667 2.91797H4.58333C4.125 2.91797 3.75 3.29297 3.75 3.7513V16.2513C3.75 16.7096 4.125 17.0846 4.58333 17.0846C5.04167 17.0846 5.41667 16.7096 5.41667 16.2513V11.2513H10.0833L10.2833 12.2513C10.3583 12.643 10.7 12.918 11.1 12.918H15.4167C15.875 12.918 16.25 12.543 16.25 12.0846V5.41797C16.25 4.95964 15.875 4.58464 15.4167 4.58464H11.5833Z" />
    </svg>
  );
};
